import FamilyMemberLabel from './FamilyMemberLabel'
export default FamilyMemberLabel
